/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SlovakianInputs */

const en_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slovakian`)
};

const fr_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slovaque`)
};

const de_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slowakisch`)
};

const it_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slovacco`)
};

const ru_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`словацкий`)
};

const es_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eslovaco`)
};

const zh_cn2_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`斯洛伐克语`)
};

const ja_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スロバキア語`)
};

const hi_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्लोवाकियाई`)
};

const pt_pt2_speechmatics_target_language_slovakian = /** @type {(inputs: Speechmatics_Target_Language_SlovakianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eslovaco`)
};

/**
* | output |
* | --- |
* | "Slovakian" |
*
* @param {Speechmatics_Target_Language_SlovakianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_slovakian = /** @type {((inputs?: Speechmatics_Target_Language_SlovakianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SlovakianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_slovakian(inputs)
	if (locale === "de") return de_speechmatics_target_language_slovakian(inputs)
	if (locale === "it") return it_speechmatics_target_language_slovakian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_slovakian(inputs)
	if (locale === "es") return es_speechmatics_target_language_slovakian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_slovakian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_slovakian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_slovakian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_slovakian(inputs)
	return en_speechmatics_target_language_slovakian(inputs)
});